// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3SbYq","calendarButtons":"ClockData_calendarButtons___S_Tz"};